export const supplierMenu = (
  organisationRouterLink: string,
  defaultToRouteSearch: boolean = false,
) => {
  const jobSearch = { label: 'Jobs Search', icon: '', routerLink: ['/app/supplierinbox'] };
  const junosRoutes = { label: "Juno's Routes", icon: '', routerLink: ['/app/routes-inbox'] };

  return [
    { label: 'Home', icon: 'home', routerLink: ['/app'] },
    ...(defaultToRouteSearch ? [junosRoutes, jobSearch] : [jobSearch, junosRoutes]),
    { label: 'My Jobs', icon: '', routerLink: ['/app/existingjobs'] },
    { label: 'My Schedule', icon: '', routerLink: ['/app/supplieravailability'] },
    { label: 'Grab and Drop', icon: '', routerLink: ['/app/supplier-interactive-schedule'] },
    {
      label: 'Job Notification Settings',
      icon: '',
      routerLink: ['/app/job-alert-settings-supplier'],
    },
    {
      label: 'Engineius Trains',
      icon: '',
      url: 'https://engineius.trainsplit.com/',
      target: '_blank',
    },
    {
      label: 'Driver Board',
      icon: '',
      url: 'https://www.engineius.co.uk/bulletin-board/',
      target: '_blank',
    },
    {
      label: 'Administration',
      icon: '',
      items: [
        { label: 'Job Tags', icon: '', routerLink: ['/app/jobtagssupplier'] },
        { label: 'Trucks', icon: '', routerLink: ['/app/trucks'] },
        { label: 'Drivers', icon: '', routerLink: ['/app/drivers'] },
        //        { label: 'Job Postcode Areas', icon: '', routerLink: ['/app/postcodes'] },
        //{label: "User Notifications", icon: "", routerLink: ["/app"]},
      ],
    },
    {
      label: 'Manage Account ',
      icon: '',
      items: [
        { label: 'Users', icon: '', routerLink: ['/app/supplierusers'] },
        { label: 'Organisation', icon: '', routerLink: [organisationRouterLink] },
        {
          label: 'Organisation Structure',
          icon: '',
          routerLink: ['/app/orgstructuresupplier'],
        },
        { label: 'Engineius Agreement', icon: '', routerLink: ['/app/agreementsupplier'] },
        { label: 'Emergency Contact', icon: '', routerLink: ['/app/emergency-contact'] },
      ],
    },
    {
      label: 'Billing & Payment',
      icon: '',
      items: [
        { label: 'Invoices', icon: '', routerLink: ['/app/supplierinvoices'] },
        { label: 'Payment Details', icon: '', routerLink: ['/app/bankaccount'] },
        { label: 'Account Codes', icon: '', routerLink: ['/app/accountcodessupplier'] },
      ],
    },
    {
      label: 'Reporting',
      icon: '',
      items: [{ label: 'Jobs', icon: '', routerLink: ['/app/report/jobs'] }],
    },
    { label: 'Supplier Agreement', icon: '', routerLink: ['/app/termsconditions/view'] },
  ];
};
